import '../grouped_elements/applied_grouped_elements_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedTagsView extends Monitoring.Views.SocialContents.Filters.AppliedGroupedElementsView
  name: 'tags'
  alias: 'Intelligent Tags'

  getDescription: (value) ->
    return I18n.t('customer.dashboard.filters.creation.tags.any_tag') if value == 'allTags'
    return I18n.t('customer.dashboard.filters.creation.tags.no_tags') if value == 'noTags'
    return @tagsByClientCode[value] || value

  _primaryName: () ->
    'primary_tags'

  _secondaryName: () ->
    'secondary_tags'

  _excludedName: () ->
    'excluded_tags'

  removeFilter: (value, list) ->
    @searchQuery.removePrimaryTag(value)   if list == @withPrefix('primary_elements')
    @searchQuery.removeSecondaryTag(value) if list == @withPrefix('secondary_elements')
    @searchQuery.removeExcludedTag(value)  if list == @withPrefix('excluded_elements')
